import React, { FC } from 'react';
import './style.scss';
import { Input, InputProps } from 'antd';

export interface InputWrapProps extends InputProps {
  width?: number;
  height?: number;
}

const InputWrap: FC<InputWrapProps> = (props) => {
  const { className, width, height, ...otherProps } = props;

  return (
    <>
      <Input
        {...otherProps}
        className={`custom_input ${width ? `width-${width}` : ''} ${height ? `height-${height}` : ''} ${className || ''}`}
      />
    </>
  );
};

export default InputWrap;
